module.exports = __webpack_public_path__ + "img/007-nicaragua.4bd4f1a1.svg";